import React, { useState, useEffect, useRef } from "react";
import Cards from "./Cards";
import {
  shippingSwitcher_1
} from "../../utils/extra/cards/swichers";
import ShipmentTable from "./ShipmentTable";
import { useCookies } from "react-cookie";
import { getShippingCardsSetData } from '../../../context/api/cards/shipping/getShippingCardsSetData'
import { getShippingTableDataSet } from '../../../context/api/tables/shipping/getShippingTableDataSet';
import Spinner from "react-bootstrap/Spinner";
import Message from "../../utils/modals/Message";

const Index = ({ lang }) => {
  const [cookies] = useCookies();
  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };
  const [showFullModal, setShowFullModal] = useState({
    isShow: false,
  });
  const fetched = useRef(false);
  const cardAction = useRef();
  const [activeCard, setActiveCard] = useState("totalShippings");
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [cardsData, setCardsData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [tableLoader, setTableLoader] = useState(true);
  const [refreshData, setRefreshData] = useState(0);
  const [btnLoader, setBtnLoader] = useState(false);
  const fetchOnStart = async () => {
    fetched.current = false;
    await getShippingCardsSetData(lang, setMessageResponse, cookies, setCardsData);
    await getShippingTableDataSet(
      lang,
      setMessageResponse,
      cookies,
      setTableData,
      setTableLoader
    );
    fetched.current = true;
  };

  useEffect(() => {
    fetchOnStart();
  }, [refreshData]);

  if (!fetched.current) {
    return (
      <div className="page_loader">
        <Spinner animation="border" variant="warning" />
      </div>
    );
  }

  const dataCard1 = cardsData.rightArray;
  const fetchTableData = async (key) => {
    setTableLoader(() => true);
    cardAction.current = key;
    await getShippingTableDataSet(
      lang,
      setMessageResponse,
      cookies,
      setTableData,
      setTableLoader
    );
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />
      <div className="shipment_p" dir={lang === "AR" ? "rtl" : "ltr"}>
        <Cards
          pageClass="shipment_p"
          lang={lang}
          dataCard1={dataCard1}
          switcher_1={shippingSwitcher_1}
          activeCard={activeCard}
          setActiveCard={setActiveCard}
          fetchTableData={fetchTableData}
        />
        <ShipmentTable
          lang={lang}
          pageClass="shipment_p"
          tableData={tableData.length > 0 ? tableData : ""}
          loader={tableLoader}
          setRefreshData={setRefreshData}
          btnLoader={btnLoader} />
      </div>
    </>

  );
};

export default Index;
